// "‹ 3 of 57 · Unassigned ›" above a ticket opened from a list, plus the switch for
// "open the next ticket after Resolve / Send". Logic: lib/ticket-nav.ts.

import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import type { ListContext, Neighbours } from '@/lib/ticket-nav';

const STEP_BTN =
  'inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-md transition-colors hover:bg-accent hover:text-foreground disabled:cursor-default disabled:opacity-40 disabled:hover:bg-transparent';

export function TicketListNav({
  nb,
  ctx,
  auto,
  onAuto,
  onStep,
}: {
  nb: Neighbours;
  ctx: ListContext;
  auto: boolean;
  onAuto: (on: boolean) => void;
  onStep: (dir: 'next' | 'prev') => void;
}) {
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground">
      <div className="inline-flex items-center gap-1" role="group" aria-label="Tickets in this list">
        <button
          type="button"
          onClick={() => onStep('prev')}
          disabled={!nb.prev}
          aria-label="Previous ticket"
          title="Previous ticket  ["
          className={STEP_BTN}
        >
          <ChevronLeft className="h-3.5 w-3.5" />
        </button>
        <span className="tabular-nums">
          {nb.index + 1} of {nb.total}
          {ctx.hasMore ? '+' : ''}
          <span className="hidden sm:inline"> · {ctx.label}</span>
        </span>
        <button
          type="button"
          onClick={() => onStep('next')}
          disabled={!nb.next}
          aria-label="Next ticket"
          title="Next ticket  ]"
          className={STEP_BTN}
        >
          <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
      <div
        className="inline-flex items-center gap-1.5"
        title="After Resolve, Snooze or Send, open the next ticket in this list instead of going back to it"
      >
        <Switch checked={auto} onCheckedChange={onAuto} label="Open the next ticket after Resolve, Snooze or Send" />
        <span className="hidden sm:inline">Open next after Resolve / Send</span>
      </div>
    </div>
  );
}
